module.exports = __webpack_public_path__ + "img/lp-header_background.4c7e7b5e.png";